import React, { Fragment } from 'react'
import { translate } from '../Services/translation'

const Navigation = ({ links = [], contentLink = null }) => {
    let menuRef = React.createRef()
    function toggleMenu() {
        menuRef.current.classList.toggle('navbar__menu--show')
    }
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null
    const hasChildrenClass = links.length > 0 ? 'has-children' : null
    const topLinks = window.__litium.topLinks
    const languageLinks = window.__litium.languageLinks

    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className="navbar__link--block navbar__icon--menu icon-menu"
                    onClick={toggleMenu}
                ></a>
            ) : (
                <Fragment>
                    <a
                        className={`navbar__link ${hasChildrenClass || ''} ${
                            additionClass || ''
                        }`}
                        href={contentLink.url || '#'}
                        dangerouslySetInnerHTML={{ __html: contentLink.name }}
                    ></a>
                    {links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right fa fa-caret-right  navbar__icon navbar__icon--open"
                            onClick={toggleMenu}
                        ></i>
                    )}
                </Fragment>
            )}
            {links.length > 0 && (
                <ul className="navbar__menu" ref={menuRef}>
                    <div className="navbar__menu-header">
                        {!contentLink ? (
                            <span
                                className="navbar__icon navbar__icon--close icon-close"
                                onClick={toggleMenu}
                            ></span>
                        ) : (
                            <Fragment>
                                <i
                                    className="navbar__icon--caret-left fa fa-caret-left navbar__icon"
                                    onClick={toggleMenu}
                                ></i>
                                <span
                                    className="navbar__title"
                                    onClick={toggleMenu}
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                ></span>
                            </Fragment>
                        )}
                    </div>
                    {links.length > 0 &&
                        links.map((link, i) =>
                            !link.name ? null : (
                                <li
                                    className="navbar__item"
                                    key={`${link.name}-${i}`}
                                >
                                    <Navigation
                                        links={link.links}
                                        contentLink={link}
                                    />
                                </li>
                            )
                        )}
                    {!contentLink && topLinks && topLinks.length > 0 && (
                        <Fragment>
                            <div className="navbar__menu-footer">
                                <i className="navbar__icon fa fa-link"></i>
                                <span className="navbar__title">
                                    {translate('toplinks.title')}
                                </span>
                            </div>
                            {topLinks.map((link, index) => (
                                <li key={index} className="navbar__footer-item">
                                    <a
                                        className="navbar__link"
                                        href={link.href}
                                    >
                                        {link.text}
                                    </a>
                                </li>
                            ))}
                        </Fragment>
                    )}{' '}
                    {!contentLink && languageLinks && languageLinks.length > 0 && (
                        <Fragment>
                            <div className="navbar__menu-footer">
                                <i className="navbar__icon fa fa-globe"></i>
                                <span className="navbar__title">
                                    {translate('languagelinks.title')}
                                </span>
                            </div>
                            {languageLinks.map((link, index) => (
                                <li key={index} className="navbar__footer-item">
                                    <a
                                        className="navbar__link"
                                        href={link.href}
                                    >
                                        {link.text}
                                    </a>
                                </li>
                            ))}
                        </Fragment>
                    )}
                </ul>
            )}
        </Fragment>
    )
}

export default Navigation
